import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.less']
})
export class DocPrintComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
